import React from "react";
import contactUsBg from "../../assets/contactUsng.png";

const Contact = () => {
  const phoneNumber = "918121877077";
  const message = "Hello! I would like to get in touch with you.";
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <div>
      <img
        src={contactUsBg}
        alt="Chat on WhatsApp"
        className="margin auto"
        style={{ width: "100%", height: "300px" }}
      />

      <div className="container my-5">
        {/* <h2 className="mb-4">Contact Us</h2> */}
        <div className="row">
          {/* Contact Form */}
          <div className="col-md-5">
            <form>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Your Name"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Your Email"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Your Message"
                ></textarea>
              </div>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success"
              >
                Send via WhatsApp
              </a>
            </form>
          </div>

          {/* Divider */}
          <div className="col-md-1 d-flex justify-content-center align-items-center">
            <div style={{ borderLeft: "2px solid #ccc", height: "100%" }}></div>
          </div>

          {/* Contact Details */}
          <div className="col-md-6">
            <h2 className="text-danger mb-3">For Agency Enquiry</h2>
            <h5>Contact Details</h5>
            <p>
              <strong>Phone:</strong> +91 81218 77077
            </p>
            <p>
              <strong>Email:</strong> sohamxxx@gmail.com
            </p>
            <p>
              <strong>Address:</strong> Block A, Nizampet, Hydernagar, Hyderabad
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
